import React from 'react';
import PropTypes from 'prop-types';
import { HiOutlineMenuAlt2 } from 'react-icons/hi';

import icon from 'assets/images/icons/icon.svg';
import HeaderProfile from './components/HeaderProfile';

function Header({ isOpen, setIsOpen }) {
  return (
    <div className="relative flex bg-white shadow-lg z-40">
      <button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        className="px-6 border-r border-gray-200 xl:hidden"
      >
        <HiOutlineMenuAlt2 className="text-3xl text-gray-500" />
      </button>
      <div className="flex-grow flex justify-between items-center px-4 py-2 xl:py-4">
        <figure>
          <img className="h-full" src={icon} alt="icon" />
        </figure>
        <HeaderProfile />
      </div>
    </div>
  );
}

Header.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default Header;
